var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "download-import-template",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_DownImportTemplate"),
        width: "385px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "border" }, [
        _c(
          "div",
          {
            style: {
              width: _vm.$selectByLang(
                "55px",
                "55px",
                "55px",
                "140px",
                "140px",
                "140px"
              ),
              height: "30px",
              background: "white",
              marginTop: "-6px",
              marginLeft: "8px"
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DownloadContent")))
            ])
          ]
        ),
        _c(
          "div",
          { staticStyle: { "margin-left": "25px", color: "#848484" } },
          [
            _c(
              "div",
              { staticStyle: { "font-size": "14.3px" } },
              [
                _c("el-checkbox", { attrs: { disabled: "", checked: "" } }),
                _vm._v(_vm._s(" " + _vm.templateFileName) + " ")
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "14px", "font-size": "14.3px" } },
              [
                _vm.sampleFileName
                  ? _c("el-checkbox", { attrs: { disabled: "", checked: "" } })
                  : _vm._e(),
                _vm._v(_vm._s(" " + _vm.sampleFileName) + " ")
              ],
              1
            )
          ]
        )
      ]),
      _c("div", { staticStyle: { height: "60px" } }, [
        _c(
          "div",
          {
            staticStyle: {
              "margin-top": "15px",
              "font-weight": "800",
              "vertical-align": "top",
              display: "inline-block"
            }
          },
          [_vm._v(_vm._s(_vm.$t("Message.Explain")))]
        ),
        _c(
          "div",
          {
            staticStyle: {
              "margin-top": "15px",
              "margin-left": "2px",
              display: "inline-block",
              color: "#848484"
            }
          },
          [
            _c("div", [
              _vm._v(
                _vm._s(
                  _vm.templateFileName +
                    _vm.$t("CargoMsg.Cargo_ImportOrderTemplateFile")
                )
              )
            ]),
            _vm.sampleFileName
              ? _c("div", { staticStyle: { "margin-top": "10px" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.sampleFileName +
                        _vm.$t(
                          "CargoMsg.Cargo_ImportOrderTemplateDataSampleFile"
                        )
                    )
                  )
                ])
              : _vm._e()
          ]
        )
      ]),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              staticStyle: { "background-color": "#006dbf", color: "white" },
              attrs: { no: "download" },
              on: {
                click: function($event) {
                  return _vm.download()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Download")))]
          ),
          _c(
            "el-button",
            {
              staticStyle: {
                "background-color": "#d7f5ff",
                color: "#479ad2",
                "border-color": "#2281c8"
              },
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }